module.exports = __webpack_public_path__ + "static/media/Reservation-BG.8a1b8087.jpg";